function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeltaUp = function SvgDeltaUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.5L0.5 6.5L8.5 6.5L4.5 0.5Z",
    fill: props.fill,
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgDeltaUp;